<section class="blog blog-grid pt-70 pb-90">
    <div class="container pairblank">
       <div class="row" >
            <div class="col-sm-12 col-md-12 col-lg-8 mb-30-xs mb-30-sm" >
                <div>
                    <h1 class="info-detail-title" i18n="@@info">Borsa Hakkında Bilinmesi Gerekenler
                    </h1>
                </div>
                <!-- <app-ads-header [adsId]="'1408095'"  [adsName]="'info-home-1'"  [adsStyle]="'#M856326ScriptRootC1408095{min-height: 300px;}'"></app-ads-header> -->
                <div class="row">
                    <ng-template ngFor let-info [ngForOf]="infoList" let-i="index" [ngForTrackBy]="trackByFnInfo">
                        <div class="col-sm-12 col-md-6 col-lg-6 wow fadeIn" data-wow-delay="100ms">
                            <div class="col-12 col-md-12 order-1 order-md-2  p-0 p-md-2">
                                <div class="aspect-ratio-container-sd info-imgsd">
                                    <a [routerLink]="['/info',info.url]" title="{{info?.title}}">
                                        <div class="col-4"style="width:auto;height:auto;"><
                                            <picture>
                                                <source media="(max-width: 90px)" srcset="{{domainURL}}halka-arz-0.webp" />
                                                <source media="(min-width: 90px)" srcset="{{domainURL}}halka-arz-0.webp" />
                                                <img loading="lazy" class="bd-placeholder-img aspect-ratio-item"
                                                data-src="{{domainURL}}halka-arz-{{(i+1)%6}}.webp" alt="{{info?.title}}" title="{{info?.title}}"
                                                height="100%" width="100%">
                                            <div class="entry--overlay"></div>
                                            </picture>
                                        </div>
                                    </a>
                                </div>
                            </div>
                            <div class="blog-entry px-2">
                                <div class="entry--content">
                                    <div class="entry--title">
                                        <ng-container [ngSwitch]="true">
                                            <h2 class="info-title" *ngSwitchCase="i == 0 || i == 1"><a [routerLink]="['/info',info.url]"
                                                title="{{info?.title}}">{{info?.title}}</a></h2>
                                            <h3 class="info-title" *ngSwitchCase="i == 2 || i == 3"><a [routerLink]="['/info',info.url]"
                                                title="{{info?.title}}">{{info?.title}}</a></h3>
                                            <h4 class="info-title" *ngSwitchDefault><a [routerLink]="['/info',info.url]"
                                                title="{{info?.title}}">{{info?.title}}</a></h4>
                                        </ng-container>
                                    </div>
                                    <div class="entry--bio" style="text-align: left;">
                                        {{info?.subTitle}}
                                    </div>
                                    <span class="entry--date">{{info.createDate | date: 'EEEE, MMMM d, y'}}</span>
                                    <div class="entry--footer">
                                        <div class="entry--more href-wrap">
                                            <a [routerLink]="['/info',info.url]" title="{{info?.title}}" class="href"> 
                                                <fa-icon [icon]="faPlus" aria-hidden="true" class="header-icons" style="font-size: 17px;"></fa-icon>
                                                Devamını oku
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ng-template>
                </div>
                <div class="row" style="margin-top: 20px;">
                    <div class="col-sm-12 col-md-12 col-lg-12 clearfix mt-10 text--center">
                        <app-mansel-pagination [pageIn]="pageInfo" (setManselPaginePageEvent)="setPage($event)">
                        </app-mansel-pagination>
                    </div>
                </div>
               <div class="widget market-pricing market-list card mb-3" style="position: relative; padding:10px;">
                    <div class="row">
                        <div class="col-4" style="width:auto;height:auto;">
                            <picture>
                                <source media="(max-width: 150px)" srcset="{{domainURL}}borsa-hakkinda-bilinmesi-gerekenler.webp" />
                                <source media="(min-width: 150px)" srcset="{{domainURL}}borsa-hakkinda-bilinmesi-gerekenler.webp" />
                                <img loading="lazy" width="150px" height="110px" src="{{domainURL}}borsa-hakkinda-bilinmesi-gerekenler.webp"
                                    alt="Borsa Hakkında Bilinmesi Gerekenler" title="Borsa Hakkında Bilinmesi Gerekenler">
                            </picture>
                        </div>
                        <div class="col-8"><strong>Borsa Hakkında Bilinmesi Gerekenler</strong>, Halka arz ve borsa alanına yeni
                            başlayanlar sizler için özel olarak hazırladığımız bu rehber niteliğindeki yazılarımızda temel konuları ele
                            almaya çalıştık.Borsa’da ve özellikle finansal alanında sıkça karşılaşacağınız terimleri derledik ve sizler
                            için açıkladık.</div>
                        <div class="w-100"></div>
                        <br>
                    </div>
                    <p>Halkaarz info adresinden yorumcularımızın kişisel yorumlarını takip eder, güvenilir kaynaklardan piyasa hakkında
                        bilgi alabilir ve kendi mali sürecinizi yönetebilirsiniz.</p>
                    <p>Halka arz analizleri yazılarımızı okumak ve güncel hisse analizlerine ulaşmak için <a
                            [routerLink]="['/ipo-calendar']" title="Halka Arz Analiz">"Halka Arz Analiz" sayfamızı ziyaret
                            edebilirsiniz.</a></p>
                    <p>Güncel Halka Arz olacak şirketleri takip etmek için <a [routerLink]="['/ipo-calendar']"
                            title="Halka Arz Takvimi">"Halka Arz Takvimi"</a> sayfamızı ziyaret edebilirsiniz.</p>
                    <p>Hissenize düşen ve <a [routerLink]="['/dividend']" title="Temettü Hisseleri">"Temettü
                            Hisseleri"</a> sayfamızı ziyaret edebilirsiniz.</p>
                    <p>Borsa'da sıkça kullanılan terimler hakkından bilgi edinmek için <a [routerLink]="['/info']"
                            title="Gerekli Bilgiler">"Gerekli Bilgiler"</a> sayfamızı ziyaret edebilirsiniz</p>
                    <p>Temettü oranlarını hesaplamak için <a [routerLink]="['/calculate']"
                            title="Temettü Hesaplama">"Temettü Hesaplama"</a> aracımızı kullanabilirsiniz.</p>
                    <p>Hisse analizleri anketlerine katılmak için <em><a
                                href="https://www.whatisproblem.com/tr/hisse-z3r3bYnCC4LaCrAaKK26"
                                title="whatisproblem.com"><strong>whatisproblem.com</strong></a></em>'u takip edebilirsiniz</p>
                    <p>Borsa'daki problemler hakkında anketlere katılmak için <em><a
                                href="https://www.whatisproblem.com/tr/borsa-A7kpCQKMyvPO11GRqQCL"
                                title="whatisproblem.com">whatisproblem.com</a></em>'u takip edebilirsiniz</p>
                    <h5 class="h6 text-dark" style="font-size:small">Borsa Hakkında Bilinmesi Gerekenler ve ek bilgilere bu sayfadan
                        ulaşabilirsiniz.</h5>
                </div>
            </div>
            <div class="col-sm-12 col-md-12 col-lg-4">
                <app-draft-month [toYear]="toYear"></app-draft-month>
                <app-draft-dividend [toYear]="toYear"></app-draft-dividend>
                <app-summary-analysis [imageStatus]="true" [count]="10"></app-summary-analysis>
            </div>
        </div>



    </div>
</section>
